export const BaseUrl = "/";
